import {
  Box,
  SimpleGrid,
  Text,
  Flex,
  Center,
} from "@chakra-ui/react";
import SectionHeading from "./sectionHeading";
import LineSection from "../lineSection";
import CardScope from "./cardScope";
import Lang from "../../Lang";

export default function HowCanHelp() {
  return (
    <Box
      color={"white"}
    >
      <LineSection />
      <Center>
        <Box

          w={{ base: "full", md: "full", xl: "6xl" }}
        >
          <SimpleGrid
            columns={{ base: 1, md: 1, xl: 2 }}
          >

            {/* left section */}
            <Center>
              <Flex
                justifyContent={"flex-end"}
                alignItems={"center"}
                w={"full"}
              >
                <Box>
                  <Box
                    w={{ base: "full", md: "md", xl: "lg" }}
                    pr={{ base: 0, md: 0 }}
                    pt={{ base: 7 }}
                  >
                    <SectionHeading
                      title="How we can help"
                    />
                  </Box>

                  <Text
                    w={{ base: "full", md: "full", xl: "xl" }}
                    py={{ base: 3, md: 4, xl: 10 }}
                    px={{ base: 4, md: 6 }}
                    fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
                  >
                    <Lang text="AppOX can help finance part of the student's tuition, provided the student performs well academically and demonstrates great enthusiasm and passion for his or her studies in technology." />
                  </Text>

                </Box>
                <Box w={"100px"}></Box>
              </Flex>
            </Center>

            {/* right section */}
            <Box  >
              <Box
                w={{ base: "full", md: "full", xl: "full" }}
                ml={{ md: "100px", xl: "100px" }}
              >
                <Flex
                  alignItems={"center"}
                >

                  <SimpleGrid
                    spacing={20}
                  >
                    <Box
                      mt={20}
                      display={{ base: "none", md: "flex" }}
                    >
                      <CardScope
                        image="img/room-interior-design.webp"
                        h="337px"
                        w={{ base: 350, md: 500, xl: "lg" }}
                      />
                    </Box>
                    <Box
                      mt={{ base: 10, md: 0 }}
                      mb={20}
                    >
                      <CardScope
                        image="img/international-day-education-celebration.webp"
                        h="337px"
                        w={{ base: 350, md: 500, xl: "lg" }}
                      />
                    </Box>
                  </SimpleGrid>
                </Flex>
              </Box>
            </Box>

          </SimpleGrid>
        </Box>
      </Center>
    </Box>
  );
}